module.exports = __webpack_public_path__ + "img/0032.6e06f454.gif";